import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import CreateEvent from "@/pages/CreateEvent";
import Petitions from "@/pages/Petitions";
import PetitionDetail from "@/pages/PetitionDetail";
import CreatePetition from "@/pages/CreatePetition";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import CreateBlog from "@/pages/CreateBlog";
import Discussions from "@/pages/Discussions";
import DiscussionDetail from "@/pages/DiscussionDetail";
import Spotlight from "@/pages/Spotlight";
import Fellowship from "@/pages/Fellowship";
import ComingSoon from "@/pages/ComingSoon";
import { PrivacyPolicy, Terms, Refunds, Shipping, Pricing, Contact } from "@/pages/Legal";
const Shell = () => (
  <>
    <Navbar />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth/google" element={<AuthCallback />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/new" element={<CreateEvent />} />
        <Route path="/events/:id/edit" element={<CreateEvent />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/petitions" element={<Petitions />} />
        <Route path="/petitions/new" element={<CreatePetition />} />
        <Route path="/petitions/:id" element={<PetitionDetail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/discussions" element={<Discussions />} />
        <Route path="/discussions/:id" element={<DiscussionDetail />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/new" element={<CreateBlog />} />
        <Route path="/blogs/:id/edit" element={<CreateBlog />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        <Route path="/spotlight" element={<Spotlight />} />
        <Route path="/fellowship" element={<Fellowship />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<ComingSoon section="Page not found" />} />
      </Routes>
    </main>
    <Footer />
  </>
);
const Router = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return <Shell />;
};
function App() {
  return (
    <div className="App min-h-screen bg-ink-base">
      <BrowserRouter>
        <AuthProvider>
          <Router />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
export default App;
